<template>
    <div>
        <div class="modal fade" id="layoutArquivoModal" tabindex="-1" role="dialog"
            aria-labelledby="layoutCartaoModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-md modal-dialog-scrollable" role="document">
                <div v-if="layout" class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="layoutArquivoModalLabel">Layout Arquivo Retorno</h5>
                        <button type="button" class="close" @click="fechar()">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col col-12 col-md-12">
                                <az-input label="Nome" placeholder="Nome do Layout..." v-model="layout.st_nome" />
                            </div>
                        </div>
                        <div class="row">
                            <div class="col col-12 col-md-12">
                                <az-input 
                                    label="Motivo de Glosa Default"
                                    type="autocomplete" 
                                    optionsMode="aql"
                                    optionsData="id_motivo_glosa" 
                                    optionsDisplay="search"
                                    :optionsSync="false"
                                    service="motivos_glosa.index"
                                    placeholder="Selecionar Motivo de Glosa..."
                                    v-model="layout.id_motivo_glosa">
                                </az-input>
                            </div>
                        </div>

                        <AzSubTitle title="Número das Colunas"></AzSubTitle>
                        <div v-for="(coluna, index) in layout.js_layout" :key="index" class="form-row">
                            <div class="col col-12 col-md-12">
                                <az-input :label="coluna.st_search" sizing="sm" v-model="coluna.in_numero" />
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click="fechar()">Fechar</button>
                        <button @click="salvar()" type="button" class="btn btn-success">Atualizar</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import azInput from "@/components/shared/forms/AzInput.vue";
import $ from 'jquery';
import AzSubTitle from "@/components/util/AzSubTitle.vue";

export default {

    components: {
        AzSubTitle,
        azInput
    },

    data() {
        return {
            layout: null,

            campos: [
                {
                    'st_search': 'Número Guia na Operadora',
                    'st_nome_coluna': 'numero_guia_prestador',
                    'in_numero': ''
                },

                {
                    'st_search': 'Nome Beneficiário',
                    'st_nome_coluna': 'nome_beneficiario',
                    'in_numero': ''
                },

                {
                    'st_search': 'Data',
                    'st_nome_coluna': 'data',
                    'in_numero': ''
                },

                {
                    'st_search': 'Código do procedimento',
                    'st_nome_coluna': 'codigo_procedimento',
                    'in_numero': ''
                },

                {
                    'st_search': 'Descrição do procedimento',
                    'st_nome_coluna': 'descricao_procedimento',
                    'in_numero': ''
                },

                {
                    'st_search': 'Quantidade',
                    'st_nome_coluna': 'quantidade',
                    'in_numero': ''
                },

                {
                    'st_search': 'Valor Apresentado',
                    'st_nome_coluna': 'valor_apresentado',
                    'in_numero': ''
                },

                {
                    'st_search': 'Valor liberado',
                    'st_nome_coluna': 'valor_liberado',
                    'in_numero': ''
                },

                {
                    'st_search': 'Valor Pro Rata',
                    'st_nome_coluna': 'valor_pro_rata',
                    'in_numero': ''
                },

                {
                    'st_search': 'Valor Glosado',
                    'st_nome_coluna': 'valor_glosado',
                    'in_numero': ''
                },

                {
                    'st_search': 'Código da Glosa',
                    'st_nome_coluna': 'codigo_glosa',
                    'in_numero': ''
                },

                // agrupar por guia e por procedimento (somando os valores liberados) ignorando as quantidades
                // glosa = valor do klingo - valor liberado do procedimento agrupado + pro rata

            ]

        }
    },

    methods: {
        open(layout = null) {

            if (layout) {
                this.layout = layout;
                this.layout.js_layout = this.campos.map((campo) => {
                    const index = this.layout.js_layout.findIndex((item) => item.st_nome_coluna === campo.st_nome_coluna);
                    if (index === -1) {
                        return {
                            ...campo,
                            in_numero: ''
                        }
                    } else {
                        return {
                            ...this.layout.js_layout[index],
                            st_search: campo.st_search
                        };
                    }
                });


            } else {
                this.layout = {
                    st_nome: '',
                    js_layout: this.campos,
                    fl_ativo: true
                }
            }

            $('#layoutArquivoModal').modal('show');
        },

        fechar() {
            $('#layoutArquivoModal').modal('hide');
        },

        salvar() {
            this.$util.atualizar(this, {
                service: 'layout-arquivo-retorno',
                dados: {
                    ...this.layout,
                },
                toast: true,
                callback: () => {
                    this.fechar();
                    this.$emit('refresh');
                }
            });
        }

    }
}
</script>

<style scoped></style>
